/* CARLINA – Configurateur natif du kit (culotte + taille, serviettes, pochette, trousse) */
(function () {
  'use strict';
  function qs(r, s) { return r.querySelector(s); }
  function qsa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function bring(el, offset) {
    if (!el) return;
    var r = el.getBoundingClientRect();
    if (r.top < 80 || r.top > window.innerHeight * 0.6) {
      window.scrollBy({ top: r.top - (offset || 100), behavior: 'smooth' });
    }
  }

  function init(root) {
    if (root.__clkb) return;
    root.__clkb = true;
    var steps = qsa(root, '.cl-kb__step');
    var state = {};
    var addBtn = qs(root, '.cl-kb__add');
    var msg = qs(root, '.cl-kb__msg');
    var bar = qs(root, '.cl-kb__bar span');
    var count = qs(root, '.cl-kb__count');
    var remain = qs(root, '.cl-kb__remain');

    function needSize(step) { return step.getAttribute('data-need-size') === 'true'; }
    function ready(step) {
      var s = state[step.getAttribute('data-key')];
      if (needSize(step) && !s.size) return false;
      return !!s.value;
    }
    function summary(step) {
      var s = state[step.getAttribute('data-key')];
      return (s.size ? 'Taille ' + s.size + ' \u00b7 ' : '') + s.value;
    }
    function setDis(btn, on) { btn.setAttribute('aria-disabled', on ? 'true' : 'false'); }
    function open(step, scroll) {
      steps.forEach(function (st) {
        var on = st === step;
        st.classList.toggle('is-open', on);
        qs(st, '.cl-kb__head').setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      if (step && scroll) bring(qs(step, '.cl-kb__head'));
    }
    function refresh() {
      var done = steps.filter(function (s) { return s.classList.contains('is-done'); }).length;
      var left = steps.length - done;
      bar.style.width = (done / steps.length * 100) + '%';
      count.textContent = done + '/' + steps.length;
      setDis(addBtn, left > 0);
      root.classList.toggle('is-complete', left === 0);
      remain.textContent = left === 0
        ? 'Son kit est pr\u00eat, il ne reste plus qu\u2019\u00e0 l\u2019ajouter !'
        : (left === 1 ? 'Plus qu\u20191 choix pour composer son kit' : 'Plus que ' + left + ' choix pour composer son kit');
      if (left === 0) msg.hidden = true;
    }

    steps.forEach(function (step, i) {
      var key = step.getAttribute('data-key');
      state[key] = {};
      var head = qs(step, '.cl-kb__head');
      var confirm = qs(step, '.cl-kb__confirm');
      var val = qs(step, '.cl-kb__val');
      var pick = qs(step, '.cl-kb__pick');
      var foot = qs(step, '.cl-kb__foot');

      function updPick() {
        if (!pick) return;
        var s = state[key];
        var img = qs(pick, 'img'), strong = qs(pick, 'strong'), sub = qs(pick, '.cl-kb__pick-sub');
        if (s.img) {
          img.src = s.img;
          img.hidden = false;
          if (foot) foot.classList.add('has-img');
        }
        if (s.value) {
          strong.textContent = s.value;
          sub.textContent = needSize(step) ? (s.size ? 'Taille ' + s.size : 'Choisis aussi sa taille') : 'Ton choix';
        } else if (s.size) {
          strong.textContent = 'Taille ' + s.size;
          sub.textContent = 'Choisis maintenant un motif';
        }
      }
      function upd() {
        var ok = ready(step);
        setDis(confirm, !ok);
        if (step.classList.contains('is-done')) {
          if (ok) { val.textContent = summary(step); }
          else { step.classList.remove('is-done'); val.textContent = val.getAttribute('data-default'); refresh(); }
        }
      }

      head.addEventListener('click', function () {
        open(step.classList.contains('is-open') ? null : step, false);
      });
      qsa(step, '.cl-kb__size').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          qsa(step, '.cl-kb__size').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          state[key].size = b.getAttribute('data-value');
          updPick(); upd();
        });
      });
      qsa(step, '.cl-kb__sw').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          qsa(step, '.cl-kb__sw').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          state[key].value = b.getAttribute('data-value');
          state[key].img = b.getAttribute('data-img') || '';
          updPick(); upd();
        });
      });
      confirm.addEventListener('click', function () {
        if (!ready(step)) {
          if (pick) {
            var sub = qs(pick, '.cl-kb__pick-sub');
            sub.textContent = (needSize(step) && !state[key].size) ? 'Choisis d\u2019abord sa taille' : 'Choisis d\u2019abord un motif';
            pick.classList.remove('is-shake');
            void pick.offsetWidth;
            pick.classList.add('is-shake');
          }
          return;
        }
        step.classList.add('is-done');
        val.textContent = summary(step);
        refresh();
        var next = null;
        for (var j = 1; j <= steps.length; j++) {
          var c = steps[(i + j) % steps.length];
          if (!c.classList.contains('is-done')) { next = c; break; }
        }
        open(next, true);
        if (!next) bring(addBtn, 180);
      });
    });

    addBtn.addEventListener('click', function () {
      if (addBtn.getAttribute('aria-disabled') === 'true') {
        var first = steps.filter(function (s) { return !s.classList.contains('is-done'); })[0];
        msg.textContent = 'Termine les choix de son kit avant de l\u2019ajouter au panier.';
        msg.hidden = false;
        if (first) open(first, true);
        return;
      }
      var props = {};
      steps.forEach(function (st) {
        var s = state[st.getAttribute('data-key')];
        if (needSize(st)) props[st.getAttribute('data-size-label')] = s.size;
        props[st.getAttribute('data-label')] = s.value;
      });
      var cart = document.querySelector('cart-drawer');
      var body = { items: [{ id: parseInt(root.getAttribute('data-variant'), 10), quantity: 1, properties: props }] };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      addBtn.classList.add('is-loading');
      msg.hidden = true;
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'Une erreur est survenue, r\u00e9essaie.');
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cl-kit-builder', cartData: res.d });
          }
          if (cart && typeof cart.renderContents === 'function' && res.d.sections) {
            cart.classList.remove('is-empty');
            cart.renderContents(res.d);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (e) { msg.textContent = e.message; msg.hidden = false; })
        .then(function () { addBtn.classList.remove('is-loading'); });
    });

    open(steps[0], false);
    refresh();
  }

  function boot() { qsa(document, '[data-cl-kit-builder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
